<template>
  <div>
    <div
      class="saved-range"
      v-bind:class="'level-' + level"
    >
      <div class="dropdown" v-bind:class="{
        'leaf': !savedRange.children,
        'visibility-hidden': !isBeingHovered,
      }">
        <span class="glyphicon glyphicon-option-vertical" data-toggle="dropdown"></span>
        <ul class="dropdown-menu">
          <li v-on:click="editName()">
            <a><span class="glyphicon glyphicon-edit"></span> Edit name</a>
          </li>
          <li v-if="!savedRange.children" v-on:click="$emit('showRange', indexes)">
            <a><span class="glyphicon glyphicon-expand"></span> Show range</a>
          </li>
          <li class="divider"></li>
          <li v-on:click="$emit('remove', indexes)">
            <a><span class="glyphicon glyphicon-trash"></span> Remove</a>
          </li>
          <li v-on:click="$emit('addChild', indexes)">
            <a><span class="glyphicon glyphicon-plus"></span> Add child</a>
          </li>
          <li v-on:click="$emit('addSibling', indexes)">
            <a><span class="glyphicon glyphicon-plus"></span> Add sibling</a>
          </li>
          <li role="separator" class="divider"></li>
          <li v-if="isMoveUpPossible" v-on:click="$emit('moveUp', indexes)">
            <a><span class="glyphicon glyphicon-chevron-up"></span> Move up</a>
          </li>
          <li v-if="isMoveDownPossible" v-on:click="$emit('moveDown', indexes)">
            <a><span class="glyphicon glyphicon-chevron-down"></span> Move down</a>
          </li>
          <li v-if="isIndentRightPossible" v-on:click="$emit('indentRight', indexes)">
            <a><span class="glyphicon glyphicon-indent-right"></span> Indent right</a>
          </li>
          <li v-if="isIndentLeftPossible" v-on:click="$emit('indentLeft', indexes)">
            <a><span class="glyphicon glyphicon-indent-left"></span> Indent left</a>
          </li>
        </ul>
      </div>
      <span
        v-if="savedRange.children"
        class="glyphicon"
        v-bind:class="{
          'glyphicon-triangle-bottom': !savedRange.collapsed,
          'glyphicon-triangle-right': savedRange.collapsed
        }"
        v-on:click="toggleIsCollapsed()"
      ></span>
      <input
        v-if="savedRange.editNameMode"
        ref="editName"
        type="text"
        v-model="savedRange.name"
        v-on:blur="finishEditingName()"
      >
      <span
        v-else
        v-on:click="handleNameClick()"
        v-on:dblclick="editName()"
        class="saved-range-name"
        v-bind:class="{
          'selected': isSelected,
        }"
      >
        {{ savedRange.name }}
      </span>
    </div>
    <saved-range
      v-if="savedRange.children && !savedRange.collapsed"
      v-for="(child, childIndex) in savedRange.children"
      v-bind:key="child.id"
      v-bind:savedRange="child"
      v-bind:indexes="getChildIndexes(childIndex)"
      v-bind:savedRanges="savedRanges"
      v-on:showRange="$emit('showRange', $event)"
      v-bind:indexesOfSelectedSavedRange="indexesOfSelectedSavedRange"
      v-on:remove="$emit('remove', $event)"
      v-on:addChild="$emit('addChild', $event)"
      v-on:addSibling="$emit('addSibling', $event)"
      v-on:moveUp="$emit('moveUp', $event)"
      v-on:moveDown="$emit('moveDown', $event)"
      v-on:indentRight="$emit('indentRight', $event)"
      v-on:indentLeft="$emit('indentLeft', $event)"
    ></saved-range>
  </div>
</template>

<script>
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  name: 'saved-range',
  props: ['savedRange', 'indexes', 'savedRanges', 'indexesOfSelectedSavedRange'],
  data: function () {
    return {
      isBeingHovered: true, // for now I'm hardcoding this; it should only happen on hover
    };
  },
  computed: {
    level: function () {
      return this.indexes.length - 1;
    },
    isSelected: function () {
      return _.isEqual(this.indexes, this.indexesOfSelectedSavedRange);
    },
    isMoveUpPossible: function () {
      if (this.indexes.length === 1 && this.indexes[0] === 0) {
        return false;
      }
      return true;
    },
    isMoveDownPossible: function () {
      let arr = utilities.general.getArrayFromNextToLastArrayIndex(this.savedRanges, this.indexes);
      return !!arr[this.indexes[this.indexes.length - 1] + 1];
    },
    isIndentRightPossible: function () {
      return this.indexes[this.indexes.length - 1] !== 0;
    },
    isIndentLeftPossible: function () {
      return this.level > 0;
    },
  },
  methods: {
    toggleIsCollapsed: function () {
      this.savedRange.collapsed = !this.savedRange.collapsed;
    },
    getChildIndexes: function (childIndex) {
      let currIndexes = _.cloneDeep(this.indexes);
      currIndexes.push(childIndex);
      return currIndexes;
    },
    editName: function () {
      let self = this;

      self.savedRange.editNameMode = true;
      setTimeout(function () {
        self.$refs.editName.focus();
      }, 0);
    },
    finishEditingName: function () {
      this.savedRange.editNameMode = false;
    },
    handleNameClick: function () {
      if (this.savedRange.children) {
        this.toggleIsCollapsed()
      } else {
        this.$emit('showRange', this.indexes);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "src/assets/mixins";

  .indent {
    margin-left: 25px;
  }

  .saved-range-name {
    cursor: pointer;
  }

  .selected {
    font-weight: bold;
  }

  .glyphicon {
    cursor: pointer;
    color: lightgray;
  }

  .glyphicon-triangle-right, .glyphicon-triangle-bottom {
    @include noselect();
  }

  .level-1 { margin-left: 25px; }
  .level-2 { margin-left: 50px; }
  .level-3 { margin-left: 75px; }
  .level-4 { margin-left: 100px; }
  .level-5 { margin-left: 125px; }
  .level-6 { margin-left: 150px; }
  .level-7 { margin-left: 175px; }
  .level-8 { margin-left: 200px; }

  .leaf {
    margin-left: 23px;
  }

  .dropdown {
    display: inline;

    .dropdown-menu li {
      cursor: pointer;
      font-size: 18px;

      a {
        padding: 10px 25px;
      }
    }
  }

  @media (max-device-width: 768px) {
    .saved-range {
      .glyphicon-triangle-bottom, .glyphicon-triangle-right {
        display: none;
      }

      .dropdown {
        visibility: visible;
      }

      .glyphicon-option-vertical {
        padding: 1em 1.5em;
      }

      .dropdown-menu li a {
        padding: 15px 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/general/saved-range.vue